// import api from "@/api";

import axios from "@/axios";

const getters = {
    timerData(state) {
        return state.timerData;
    },
};

const state = {
    timerData: false,
    loading: false,
};

export const SET_TIMER_DATA = "setTimerData";
export const SET_TIMER_DATA_LOADING = "setTimerDataLoading";
const mutations = {
    [SET_TIMER_DATA](state, payload) {
        state.timerData = payload;
    },
    [SET_TIMER_DATA_LOADING](state, payload) {
        state.loading = payload;
    },
};

export const GET_TIMER_DATA = "getTimerData";
const actions = {
    [GET_TIMER_DATA](context) {
        if (!context.state.loading) {
            context.commit(SET_TIMER_DATA_LOADING, true);
            return new Promise((resolve, reject) => {
                axios
                    .post("/timer.active", {
                        token: context.getters.token,
                    })
                    .then((response) => {
                        // console.log(response.headers["content-type"]);
                        if (
                            response.headers["content-type"] ===
                            "text/html; charset=UTF-8"
                        ) {
                            console.log("OPS..");
                            setTimeout(() => {
                                context.commit(SET_TIMER_DATA_LOADING, false);
                                context.dispatch(GET_TIMER_DATA).then(resolve);
                            }, 500);
                        } else {
                            context.commit(SET_TIMER_DATA, response.data);
                            context.commit(SET_TIMER_DATA_LOADING, false);
                            resolve(response.data);
                        }
                    })
                    .catch((data) => {
                        context.commit(SET_TIMER_DATA_LOADING, false);
                        reject(data.response);
                    });
            });
        }
    },
};

export default {
    getters,
    state,
    mutations,
    actions,
};
